import React from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../state";
import TreeCard from "../../../../../atoms/ActiveLearning/TreeCard";
import SaveAnswerButton from "../../../../../atoms/ActiveLearning/SaveAnswerButton";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson14/Material/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson14/Material/Issue2";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson14MaterialProps = {
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson14Material = (props: Lesson14MaterialProps) => {
  const lastAnswers = ["ターゲット", "理由", "場面"];

  return (
    <>
      <div className={styles.section}>
        <div className={styles.review}>
          <p className={styles.title}>前回の振り返り</p>
          <div className={styles.tree}>
            <TreeCard title={"問い"} text={"回答データがありません。"} />
            <ul className={styles.branchList}>
              {lastAnswers.map((lastAnswer, index) => (
                <li key={index} className={styles.branch}>
                  <div className={styles.labelWrapper}>
                    <span className={styles.label}>{lastAnswer}</span>
                  </div>
                  <ul className={styles.answerList}>
                    <li className={clsx(styles.answer, styles.single)}>
                      回答データがありません。
                    </li>
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.section}>
        <Issue1 issue={props.findIssue && props.findIssue(1)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue2 issue={props.findIssue && props.findIssue(2)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
    </>
  );
};
export default Lesson14Material;
